import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { ToastrService } from 'ngx-toastr';
import { switchMap, map, catchError } from 'rxjs/operators';

import { SmsService } from '../services';
import {
  SmsActionTypes,
  GetStatisticsOverview,
  GetStatisticsOverviewSuccess,
  GetStatisticsOverviewFail,
  GetCountryCodes,
  GetCountryCodesSuccess,
  GetCountryCodesFail,
  GetTotalTimeline,
  GetTotalTimelineSuccess,
  GetTotalTimelineFail,
} from '../actions/sms.actions';

@Injectable()
export class SmsEffects {
  @Effect()
  getStatistics$ = this.actions$.pipe(
    ofType(SmsActionTypes.GetStatisticsOverview),
    switchMap(({ payload: { dateRange, accountId } }: GetStatisticsOverview) =>
      this.service.getStatisticsOverview(dateRange, accountId).pipe(
        map((statistics) => new GetStatisticsOverviewSuccess(statistics)),
        catchError((error) => [new GetStatisticsOverviewFail(error)]),
      ),
    ),
  );

  @Effect()
  getCountryCodes$ = this.actions$.pipe(
    ofType(SmsActionTypes.GetCountryCodes),
    switchMap(({ payload: { dateRange, accountId } }: GetCountryCodes) =>
      this.service.getCountryCodes(dateRange, accountId).pipe(
        map((statistics) => new GetCountryCodesSuccess(statistics)),
        catchError((error) => [new GetCountryCodesFail(error)]),
      ),
    ),
  );

  @Effect()
  getTotalTimeline$ = this.actions$.pipe(
    ofType(SmsActionTypes.GetTotalTimeline),
    switchMap(({ payload: { timeSpans, accountId } }: GetTotalTimeline) =>
      this.service.getTotalTimeline(timeSpans, accountId).pipe(
        map((statistics) => new GetTotalTimelineSuccess(statistics)),
        catchError((error) => [new GetTotalTimelineFail(error)]),
      ),
    ),
  );

  constructor(
    private readonly actions$: Actions,
    private readonly service: SmsService,
    private readonly toastr: ToastrService,
  ) {}
}
